import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@/components/LoadingSpinner';

// Lazy load heavy components
export const LazyLiveStreamPreview = lazy(() =>
  import('@/components/LiveStreamPreview').then((module) => ({
    default: module.LiveStreamPreview,
  }))
);

export const LazyScrollEngagementPrompt = lazy(() =>
  import('@/components/ScrollEngagementPrompt').then((module) => ({
    default: module.ScrollEngagementPrompt,
  }))
);

export const LazyExitIntentModal = lazy(() =>
  import('@/components/ExitIntentModal').then((module) => ({
    default: module.ExitIntentModal,
  }))
);

export const LazyOnboardingTour = lazy(() =>
  import('@/components/OnboardingTour').then((module) => ({
    default: module.OnboardingTour,
  }))
);

// Loading fallback component
export const ComponentLoader = ({ minHeight = '200px' }: { minHeight?: string }) => (
  <div style={{ minHeight }} className="flex items-center justify-center">
    <LoadingSpinner size="md" />
  </div>
);

// Wrapper components with suspense
export const LiveStreamPreviewWithSuspense = () => (
  <Suspense fallback={<ComponentLoader minHeight="400px" />}>
    <LazyLiveStreamPreview />
  </Suspense>
);

export const ScrollEngagementPromptWithSuspense = () => (
  <Suspense fallback={null}>
    <LazyScrollEngagementPrompt />
  </Suspense>
);

export const ExitIntentModalWithSuspense = () => (
  <Suspense fallback={null}>
    <LazyExitIntentModal />
  </Suspense>
);

export const OnboardingTourWithSuspense = () => (
  <Suspense fallback={null}>
    <LazyOnboardingTour />
  </Suspense>
);
